import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import Navbar from '../components/common/Navabar';
import Footer from '../components/common/Footer';

const TermsAndConditions = () => {
    return (
        <div>
            <Navbar />
            <Container maxWidth="md" sx={{ marginTop: '2rem' }}>

                <Typography variant="h6">Terms and Conditions</Typography>
                <Box>
                    <h2 className='my-2 font-bold'>1. Introduction</h2>
                    <p className='my-2'>Welcome to <strong>QBus Rentals</strong>! By accessing and using our website or services, you agree to comply with and be bound by the following Terms and Conditions. If you do not agree with any part of these terms, please refrain from using our services.</p>

                    <h3 className='my-2 font-bold'>2. Services Provided</h3>
                    <p className='my-2'><strong>QBus Rentals</strong> offers a variety of travel-related services, including:</p>
                    <ul>
                        <li>Bus and coach rentals for tours and events</li>
                        <li>Customizable travel packages for group travel</li>
                        <li>Transportation solutions for corporate and private groups</li>
                        <li>Travel consultation services</li>
                    </ul>

                    <h3 className='my-2 font-bold'>3. Booking Process</h3>
                    <ul>
                        <li><strong>Reservation Confirmation</strong>: Bookings are confirmed once we send a booking confirmation email with all relevant details.</li>
                        <li><strong>Payment Terms</strong>: All payments for bookings must be made through our approved payment methods, including credit cards, bank transfers, or other methods available on the website.</li>
                        <li><strong>Cancellation</strong>: Cancellations must be made in accordance with our Refund Policy, which may involve charges depending on the time of cancellation.</li>
                    </ul>

                    <h3 className='my-2 font-bold'>4. Customer Responsibilities</h3>
                    <ul>
                        <li><strong>Travel Documentation</strong>: You are responsible for ensuring you have the necessary documentation for travel, such as IDs, permits, or any other documents required for specific destinations or services.</li>
                        <li><strong>Health and Fitness</strong>: You are responsible for ensuring that all travelers are in suitable health and fitness for the journey, particularly for longer trips or tours.</li>
                        <li><strong>Safety Regulations</strong>: All passengers must comply with safety regulations and instructions provided by the driver or tour guide during travel.</li>
                    </ul>

                    <h3 className='my-2 font-bold'>5. Changes to Bookings</h3>
                    <ul>
                        <li><strong>Customer Changes</strong>: If you wish to change any details of your booking (e.g., travel date, destination), we will do our best to accommodate your request, subject to availability and applicable charges.</li>
                        <li><strong>Provider Changes</strong>: We reserve the right to make changes to services (such as transport routes or schedules) due to unforeseen circumstances such as weather, road conditions, or third-party service providers.</li>
                    </ul>

                    <h3 className='my-2 font-bold'>6. Liability</h3>
                    <p><strong>QBus Rentals</strong> is not responsible for any direct or indirect damages, losses, or delays incurred during travel. We are also not liable for any accidents or injuries that occur during your trip. Passengers are expected to follow all safety protocols.</p>

                    <h3 className='my-2 font-bold'>7. Insurance</h3>
                    <p>We recommend that all travelers purchase travel insurance for coverage on accidents, delays, or cancellations that may occur during the trip.</p>

                    <h3 className='my-2 font-bold'>8. Governing Law</h3>
                    <p>These Terms and Conditions are governed by the laws of [India].</p>

                    <h3 className='my-2 font-bold'>9. Modifications to Terms</h3>
                    <p>We may update these Terms and Conditions from time to time. All updates will be posted on our website, and the revised terms will apply to all bookings made after the update.</p>

                    <h3 className='my-2 font-bold'>10. As we are into the customaizable pricing , we dont have fixed price .</h3>

                    <p>Our services will starts from basically 10000/-</p>
                    <p> Per kilometer basically it will be 9 rs /-</p>
                </Box>
            </Container>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;
